export default function (data, month_data) {
  // const month_data = [
  //   "03/24",
  //   "03/23",
  //   "03/22",
  //   "03/21",
  //   "03/20",
  //   "03/19",
  //   "03/18",
  //   "03/17",
  // ];
  return {
    chart: {
      backgroundColor: "rgba(0,0,0,0)",
    },
    title: {
      text: "",
    },
    subtitle: {
      text: "",
    },
    yAxis: {
      title: {
        align: "high",
        text: "单位：次",
        offset: 0,
        rotation: 0,
        y: -20,
        style: {
          color: "#fff",
        },
      },
      gridLineWidth: 1,
      gridLineColor: "#2A85C5",
      labels: {
        style: {
          color: "#fff",
        },
      },
      lineWidth: 1,
    },
    xAxis: [
      {
        labels: {
          style: {
            color: "#fff",
          },
        },
        categories: month_data,
        tickWidth: 0,
        lineWidth: 1,
      },
    ],
    legend: {
      itemStyle: {
        color: "#fff",
      },
      align: "right",
      verticalAlign: "top",
    },
    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
      },
    },
    colors: ["#55dba8", "#d39d5f"],
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "上行",
        data: data.up,
      },
      {
        name: "下行",
        data: data.down,
      },
    ],
  };
}
